import React from 'react';
import { Package, Plug, Target } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="py-20 relative overflow-hidden" data-id="element-449">
      {/* Video Background */}
      <div className="absolute inset-0 z-0" data-id="element-450">
        <div className="absolute inset-0 bg-white/40 z-10" data-id="element-451"></div>
        <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-452">
          <source src="https://cdn.magicpatterns.com/uploads/mDGvpjFBDgEvF12sEZF8rw/SprayClip.mp4" type="video/mp4" data-id="element-453" />
          <source src="https://cdn.magicpatterns.com/uploads/mDGvpjFBDgEvF12sEZF8rw/SprayClip.mov" type="video/quicktime" data-id="element-454" />
          <source src="https://cdn.magicpatterns.com/uploads/mDGvpjFBDgEvF12sEZF8rw/SprayClip.undefined" type="video/mp4" data-id="element-455" />
        </video>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20" data-id="element-456">
        <div className="text-center mb-16" data-id="element-457">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-458">
            How It Works
          </h2>
          <p className="text-xl text-gray-800 font-medium" data-id="element-459">
            Three simple steps to faster, safer spraying.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto" data-id="element-460">
          <div className="text-center" data-id="element-461">
            <div className="w-20 h-20 bg-brand-yellow rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-462">
              <Package className="h-10 w-10 text-brand-dark" data-id="element-463" />
            </div>
            <div className="text-brand-yellow font-bold text-lg mb-3 drop-shadow-sm" data-id="element-464">
              Step 1
            </div>
            <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-465">
              Order Your Kit
            </h3>
            <p className="text-gray-800 font-medium" data-id="element-466">
              Choose the DIY or Complete ForceX system that fits your workflow.
            </p>
          </div>

          <div className="text-center" data-id="element-467">
            <div className="w-20 h-20 bg-brand-yellow rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-468">
              <Plug className="h-10 w-10 text-brand-dark" data-id="element-469" />
            </div>
            <div className="text-brand-yellow font-bold text-lg mb-3 drop-shadow-sm" data-id="element-470">
              Step 2
            </div>
            <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-471">
              Plug It In
            </h3>
            <p className="text-gray-800 font-medium" data-id="element-472">
              No batteries, no charging. Just reliable, corded power.
            </p>
          </div>

          <div className="text-center" data-id="element-473">
            <div className="w-20 h-20 bg-brand-yellow rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-474">
              <Target className="h-10 w-10 text-brand-dark" data-id="element-475" />
            </div>
            <div className="text-brand-yellow font-bold text-lg mb-3 drop-shadow-sm" data-id="element-476">
              Step 3
            </div>
            <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-477">
              Spray with Precision
            </h3>
            <p className="text-gray-800 font-medium" data-id="element-478">
              Drop the intake line into your container and get to work.
            </p>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-479">
          <a href="#kits" className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-14 px-8 text-lg" data-id="element-480">
            View Kits
          </a>
        </div>
      </div>
    </section>;
}